import { AnalyticsTranslationKeys, InspectionTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';

export type InspectionSummaryPart = 'count' | 'failedFactor' | 'result';

export type InspectionSummaryPartConfig = Readonly<{
  part: InspectionSummaryPart;
  titleId: TranslationKey;
  subtitleId: TranslationKey;
}>;

export const INSPECTION_SUMMARY_PARTS: readonly InspectionSummaryPartConfig[] =
  [
    {
      part: 'count',
      titleId: AnalyticsTranslationKeys.inspectionsChart,
      subtitleId: AnalyticsTranslationKeys.cardSubtitleInspectionCount,
    },
    {
      part: 'failedFactor',
      titleId: InspectionTranslationKeys.failedInspectionFactorChart,
      subtitleId: AnalyticsTranslationKeys.cardSubtitleFailedInspectionFactor,
    },
    {
      part: 'result',
      titleId: AnalyticsTranslationKeys.inspectionResultChart,
      subtitleId: AnalyticsTranslationKeys.cardSubtitleInspectionResult,
    },
  ];

export type InspectionSummarySeries = Readonly<{
  inspectionCount: number | undefined;
  failedFactor: number | undefined;
  inspectionResult: number | undefined;
}>;

export function toInspectionSummarySeries(
  values: readonly (number | undefined)[]
): InspectionSummarySeries {
  const [inspectionCount, failedFactor, inspectionResult] = values;
  return { inspectionCount, failedFactor, inspectionResult };
}
